<template>
  <div class="member-applica-page">
    <div class="page-title">会员申请</div>
    <pageTable
      class="yjh-iors-list"
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
      @compFn='onCustomComp'
    ></pageTable>
    <simpleDiag
      :title='title'
      :width='width'
      :onlyOK='true'
      :okText='"提交"'
      :isShow='dialogShow'
      @confirm='confirm'
      @close='close'
      class='application-diag'
    >
    <Form :model='dialogParams'  :rules='dialogRules' label-position='right' :label-width='90' ref='dialogForm'>
      <FormItem label='申请企业'>
        <div class='company'>{{dialogParams.applyCompany}}</div>
      </FormItem>
      <FormItem label='处理结果' prop='results'>
        <countArea :value='dialogParams.results' height='120px' @changeVal='changeVal'></countArea>
      </FormItem>
    </Form>
    </simpleDiag>
  </div>
</template>
<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import countArea from '@/components/countArea'
import simpleDiag from '@/components/dialogs/simpleDiag'
import { memberApplyList, memberApplyMark } from '@/api/member'
import Vue from 'vue'
export default {
  name: 'memberApplication',
  components: {
    pageTable,
    countArea,
    simpleDiag
  },
  mixins: [pageTableMixin],
  data() {
    return {
      col: [],
      dialogShow: false,
      title: '标记',
      width: '400px',
      dialogParams: {
        applyId: '', // 申请id
        results: '', // 处理结果
        applyCompany: '' // 公司名称
      },
      dialogRules: {
        results: [
          { required: true, message: ' ', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    initPage() {
      this.col = [
        { field: '', title: '序号', width: 50, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData, rowIndex) {
            return rowIndex + 1
          }
        },
        { field: 'apply_time', title: '申请时间', width: 150, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'apply_hy_level', title: '申请会员', width: 70, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData, rowIndex, pagingIndex, field) {
            const arr = ['免费会员', '初级会员', '中级会员', '高级会员']
            return arr[rowData[field]]
          }
        },
        { field: 'apply_company', title: '申请企业', width: 160, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'now_hy_level', title: '当前会员等级', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData, rowIndex, pagingIndex, field) {
            const arr = ['', '普通会员', '初级会员', '中级会员', '高级会员', 'SVIP会员']
            return arr[rowData[field] * 1 + 1]
          }
        },
        { field: 'contact_man', title: '联系人', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tel', title: '联系电话', width: 100, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'status', title: '状态', width: 60, titleAlign: 'left', columnAlign: 'left', isResize: true,
          formatter(rowData, rowIndex, pagingIndex, field) {
            if (rowData[field] === '0') {
              return '<span style="color:#DFA338;">未处理</span>'
            } else {
              return '<span>已处理</span>'
            }
          }
        },
        { field: 'results', title: '处理结果', width: 200, titleAlign: 'left', columnAlign: 'left', overflowTitle: true, isResize: true },
        { field: 'company_name', title: '操作', width: 80, titleAlign: 'left', columnAlign: 'left', isResize: true, componentName: 'memberApiOpe' }
      ]
    },
    getData() {
      memberApplyList({
        cp: this.page,
        rp: this.pageSize
      }).then(res => {
        if (res.code === 0) {
          this.tableData = res.result.data
          this.total = res.result.count
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    },
    onCustomComp(data) {
      this.dialogParams.applyId = data.apply_id
      this.dialogParams.results = data.results
      this.dialogParams.applyCompany = data.apply_company
      this.dialogShow = true
    },
    close() {
      this.dialogParams.applyId = ''
      this.dialogParams.results = ''
      this.dialogParams.applyCompany = ''
      this.dialogShow = false
      this.$refs.dialogForm.resetFields() // 使用改方法置空表单的校验信息
    },
    confirm() {
      this.$refs.dialogForm.validate(valid => {
        if (valid) {
          memberApplyMark({
            apply_id: this.dialogParams.applyId,
            results: this.dialogParams.results
          }).then(res => {
            if (res.code === 0) {
              this.close()
              this.getData()
            } else if (res.code !== 10008) {
              this.$Message.info(res.msg)
            }
          })
        } else {
          this.$Message.info('请填写处理结果')
        }
      })
    },
    changeVal(val) {
      this.dialogParams.results = val
    }
  }
}
Vue.component('memberApiOpe', {
  props: {
    rowData: Object,
    field: String,
    index: Number
  },
  methods: {
    list() {
      this.$emit('on-custom-comp', this.rowData)
    }
  },
  render: function(h) {
    const str = this.rowData.status === '0' ? '标记已处理' : ''
    return h('div', {
      class: {
        operate: true
      }
    }, [h('a', {
      on: {
        click: this.list
      }
    }, str)])
  }
})
</script>
<style lang='scss'>
  .member-applica-page {
    .page-title {
      margin-top: 10px;
      color: #5D6F80;
      font-size: 16px;
      width: 65px;
      height: 16px;
      line-height: 16px;
      // font-family: PingFangSC-Semibold;
      font-weight: 600;
    }
  }
  .application-diag {
    .ivu-form-item-error-tip {
      white-space: nowrap;
      position: absolute;
      left: 202px;
      top: 40px;
    }
    .company {
      font-size: 12px;
      max-width: 270px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .count-area {
      height:180px;
    }
  }
</style>

